import { useTranslation } from "react-i18next";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import { IDashboardCategoryValue } from "../../../../../@types/admin";
import { CHART_DONUT_COLORS } from "./chartConstants";
import { DashboardTooltip } from "./DashboardTooltip";

interface IProps {
  data: IDashboardCategoryValue[];
}

const legendStyle: React.CSSProperties = {
  fontFamily: "'Open Sans', sans-serif",
  fontSize: 12,
  color: "#727272",
};

function formatPercentSuffix(value: number, total: number): string {
  if (total <= 0) return "";
  return ` (${Math.round((value / total) * 100)}%)`;
}

export function ReferralSourceChart({ data }: IProps) {
  const { t } = useTranslation();

  const total = data.reduce((sum, d) => sum + d.value, 0);
  const pieData = data.map((d) => ({ name: d.category, value: d.value }));

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Tooltip
          content={(p) => (
            <DashboardTooltip
              {...p}
              valueLabel={t("reports_charts_referralsValue")}
              valueSuffix={formatPercentSuffix(
                Number(p.payload?.[0]?.value ?? 0),
                total
              )}
            />
          )}
        />
        <Legend
          verticalAlign="bottom"
          iconType="circle"
          wrapperStyle={legendStyle}
        />
        <Pie
          data={pieData}
          dataKey="value"
          nameKey="name"
          innerRadius="55%"
          outerRadius="85%"
          paddingAngle={2}
          stroke="#FFFFFF"
          strokeWidth={2}
          isAnimationActive={false}
        >
          {pieData.map((_, idx) => (
            <Cell
              key={`referral-${idx}`}
              fill={CHART_DONUT_COLORS[idx % CHART_DONUT_COLORS.length]}
            />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
}
